import type { FuelType, VehiclePhotoKind, VehicleStatus, VehicleType } from '@tcrd/shared';

export interface VehicleDto {
  id: string;
  make: string;
  model: string;
  trim: string | null;
  year: number;
  color: string;
  plate: string;
  type: VehicleType;
  doors: number;
  passengerCapacity: number;
  luggageCapacity: number;
  fuel: FuelType;
  airConditioning: boolean;
  status: VehicleStatus;
  isPrimary: boolean;
  driver: { id: string; name: string } | null;
  photos: Array<{ id: string; kind: VehiclePhotoKind; url: string }>;
}

export const VEHICLE_TYPE_LABEL: Record<VehicleType, string> = {
  SEDAN: 'Sedán',
  SUV: 'SUV / Jeepeta',
  HATCHBACK: 'Hatchback',
  MINIVAN: 'Minivan',
  VAN: 'Van / Guagua',
  PICKUP: 'Camioneta',
  LUXURY: 'Lujo',
  OTHER: 'Otro',
};

export const FUEL_LABEL: Record<FuelType, string> = {
  GASOLINE: 'Gasolina',
  DIESEL: 'Diésel',
  HYBRID: 'Híbrido',
  ELECTRIC: 'Eléctrico',
  LPG: 'GLP',
  OTHER: 'Otro',
};

export const STATUS_LABEL: Record<VehicleStatus, string> = { ACTIVE: 'Activo', INACTIVE: 'Inactivo', MAINTENANCE: 'En mantenimiento' };

export const PHOTO_KIND_LABEL: Record<VehiclePhotoKind, string> = {
  MAIN: 'Principal',
  FRONT: 'Frontal',
  SIDE: 'Lateral',
  REAR: 'Trasera',
  INTERIOR: 'Interior',
  OTHER: 'Otra',
};
